var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0.400024V19.6H0.383798C0.00219813 19.6 -0.115402 19.3492 0.124598 19.042L5.4874 12.1444C5.54116 12.0723 5.6097 12.0126 5.68844 11.9691C5.76717 11.9257 5.85428 11.8996 5.94393 11.8925C6.03357 11.8855 6.12369 11.8977 6.20825 11.9283C6.2928 11.9589 6.36984 12.0072 6.4342 12.07L8.137 13.6708C8.19839 13.7332 8.27337 13.7805 8.35608 13.809C8.43879 13.8376 8.52698 13.8467 8.61377 13.8355C8.70056 13.8244 8.78359 13.7933 8.85638 13.7448C8.92918 13.6962 8.98976 13.6315 9.0334 13.5556L12.6898 7.86762C12.7331 7.79221 12.7934 7.72793 12.8659 7.6799C12.9383 7.63186 13.021 7.60139 13.1073 7.5909C13.1937 7.58042 13.2812 7.59021 13.3631 7.6195C13.445 7.64879 13.5189 7.69677 13.579 7.75962L16.1842 10.2748C16.4626 10.5448 16.855 10.4908 17.053 10.1548L23.2126 0.812825C23.4118 0.474425 23.6998 0.400024 23.9998 0.400024Z",
    fill: "#F6764E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.8dd4ca0271e48da9efd30b6f976ddd33.svg";
export { ForwardRef as ReactComponent };